import { Price, Reservation } from "./reservation";
import { AlternativeCurrenciesTypes } from "../models/alternative-currency/alternative-currencies-types.enum";

export function ComputeTotalFromReservation(reservation: Reservation): Price {
  let bookingTotal: Price = reservation.totalAmount;
  let totalAmountBookingFees: Price[] = [];
  let totalAmountAltCurrencies = reservation.alternativeCurrencies.map(al => al.amount);
  let totalAmountAltCurrenciesFeesTotal = reservation.alternativeCurrenciesFees.map(al => al.fee);
  let totalAmountFeeOverrides = reservation.feeOverrides;
  let skipAltCurrencyRounding = false;
  let totalAmountCurrencyCode = reservation.totalAmount.currencyCode;
  let totalAmountVacationCash = reservation.alternativeCurrencies.filter(ac => ac.type == AlternativeCurrenciesTypes.VacationCash).map(x => x.amount);
  let altCurrencyInUse: boolean = false;

  if (!(reservation.alternativeCurrenciesFees && reservation.alternativeCurrenciesFees.length > 0)) {
    let acFees =
      reservation.alternativeCurrenciesFees.filter(
        ac => ac.fee && ac.fee.currencyCode === totalAmountCurrencyCode);
    for (let ac of acFees) {
      let newItem: Price = {
        amount: ac.fee.amount,
        currencyCode: ac.fee.currencyCode
      };
      totalAmountBookingFees.push(newItem);
    }
    altCurrencyInUse = true;
  }

  const currencyCode = (bookingTotal && bookingTotal.currencyCode) || totalAmountCurrencyCode;
  const bookinTotalWithoutFees = (bookingTotal && bookingTotal.amount) || 0;
  const bookingFeesTotal = totalAmountBookingFees.reduce((d, ac) => d += (ac && ac.amount) || 0, 0);
  let altCurrenciesTotal = totalAmountAltCurrencies.reduce((d, ac) => d += (ac && ac.amount) || 0, 0);
  const altCurrenciesFeesTotal = totalAmountAltCurrenciesFeesTotal.reduce((d, ac) => d += (ac && ac.amount) || 0, 0);

  altCurrenciesTotal = ((bookinTotalWithoutFees - altCurrenciesTotal) < 0 && !skipAltCurrencyRounding)
    ? bookinTotalWithoutFees
    : altCurrenciesTotal;

  const overridesTotal = totalAmountFeeOverrides.reduce((d, override) => d += (override && override.amount) || 0, 0);

  let retAmount = 0

  if (altCurrencyInUse == true) {
    retAmount = bookinTotalWithoutFees + bookingFeesTotal - overridesTotal - altCurrenciesTotal + altCurrenciesFeesTotal;
  } else {
    retAmount = bookinTotalWithoutFees + bookingFeesTotal - overridesTotal;
  }

  if (totalAmountVacationCash.length > 0) {
    if (totalAmountVacationCash[0].amount > 0) {
      retAmount = retAmount - totalAmountVacationCash[0].amount;
    }
  }

  return {
    amount: retAmount,
    currencyCode: currencyCode
  };

}
